import React from "react";
import "./style.css";
import HeaderEn from "../header-en";
import FooterEn from "../footer-en";
import moreAppsSVG from "./images/MoreApps.svg";
import axios from "axios";
import { FaLock, FaUser, FaEye, FaEyeSlash } from "react-icons/fa";

class SignInEn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isReceiving: false,
      usernameLogin: "",
      passwordLogin: "",
      showPassword: false,
      usernameEmpty: false,
      passwordEmpty: false,
      userOrPassError: false,
      sendMessage: "Hello,I'mInLoginPageEn",
    };
  }

  componentDidMount = async () => {
    this.handleRedirect();

    const result = await axios.get("https://request.kidiar.com/user/request", {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    if (result.data.message == "Yo, You are authenticated!") {
      window.location.href = "/en/panel";
    } else {
    }
  };

  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
  }

  submitHandler = async (event) => {
    event.preventDefault();
    if (this.state.usernameLogin == "") this.setState({ usernameEmpty: true });
    else this.setState({ usernameEmpty: false });
    if (this.state.usernameEmpty == false) {
      this.setState({ isReceiving: true });
      const result = await axios.post("https://request.kidiar.com/login/request", {
        username: this.state.usernameLogin,
        password: this.state.passwordLogin,
      });
      if (result.data.auth == false) {
        this.setState({ isReceiving: false });
        this.setState({ userOrPassError: true });
      } else if (result.data.auth == true) {
        localStorage.setItem("token", result.data.token);
        if (result.data.verified == true) {
          window.location.href = "/en/panel";
        } else {
          window.location.href = "/en/account/verify";
        }
      }
    }
  };

  render() {
    return (
      <div className="container">
        <HeaderEn />
        <div className="forms-container">
          <div className="panels-container">
            <div className="signin-panel right-panel">
              <div className="signin-signup">
                <form
                  action=""
                  className="signin-form"
                  onSubmit={this.submitHandler}
                >
                  <h2 className="signin-title">Log in to your account</h2>
                  <div className="input-field d-ltr">
                    <FaUser />
                    <input
                      type="text"
                      placeholder="Username or Email"
                      onChange={(event) => {
                        this.setState({ usernameLogin: event.target.value });
                      }}
                    ></input>
                  </div>
                  <div
                    className="input-field d-ltr d-flex"
                    style={{ position: "relative" }}
                  >
                    <FaLock />
                    <input
                      type={this.state.showPassword ? "text" : "password"}
                      placeholder="Password"
                      onChange={(event) => {
                        this.setState({ passwordLogin: event.target.value });
                      }}
                    ></input>
                    {this.state.showPassword ? (
                      <FaEyeSlash
                        onClick={() =>
                          this.setState({
                            showPassword: !this.state.showPassword,
                          })
                        }
                      ></FaEyeSlash>
                    ) : (
                      <FaEye
                        onClick={() =>
                          this.setState({
                            showPassword: !this.state.showPassword,
                          })
                        }
                      ></FaEye>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="btn solid d-flex justify-content-center align-items-center"
                  >
                    {this.state.isReceiving ? (
                      <div className="spinner"></div>
                    ) : (
                      <p>Log In</p>
                    )}
                  </button>
                  <div className="error-message">
                    {this.state.usernameEmpty && (
                      <label>*Please enter username or email</label>
                    )}
                    {this.state.userOrPassError && (
                      <label>*Username or password is not correct</label>
                    )}
                  </div>
                </form>
              </div>
            </div>
            <div className="signin-panel left-panel">
              <div className="content d-ltr">
                <h3>More features?</h3>
                <p>
                  Log in to your account and face a world of ai powered
                  features!
                </p>
              </div>
              <img className="more-apps-svg-image" src={moreAppsSVG}></img>
            </div>
          </div>
        </div>
        <FooterEn />
      </div>
    );
  }
}

export default SignInEn;
